<template>
  <div>
    <search-securities
      placeholder="Search Securities"
      :select-item="selectSecurity"
      :get-items="searchSecurities"
      :search-length="0"
    />

    <template
      v-if="payouts === null"
    >
      <v-alert
        :value="true"
        type="info"
      >
        Please choose a security first
      </v-alert>
    </template>
    <template
      v-else-if="payouts.length === 0"
    >
      <v-alert
        :value="true"
        type="warning"
      >
        No payouts for security "{{ security.name }} ({{ security.id }})" found!
      </v-alert>
    </template>
    <template
      v-else
    >
      <v-tooltip
        top
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="selectedPayoutIds.length > 1"
            color="secondary"
            fab
            dark
            absolute
            top
            right
            @click.stop="onSendMultiplePayoutEmail"
            v-on="on"
          >
            <v-icon>email</v-icon>
          </v-btn>
        </template>
        <span>Send Multiple Payout Email</span>
      </v-tooltip>
      <v-card-title>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter"
        />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="payouts"
        :pagination.sync="pagination"
        :loading="isLoading"
        loading-text="Loading..."
        disable-initial-sort
        :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr
            @click="toggleSelected(props.item)"
          >
            <td
              @click.stop="() => null"
            >
              <v-tooltip
                top
                dark
              >
                <template v-slot:activator="{ on }">
                  <v-checkbox
                    :key="props.item.payout_id"
                    v-model="selectedPayoutIds"
                    :value="props.item.payout_id"
                    multiple
                    class="mt-3"
                    v-on="on"
                  />
                </template>
                <span>Aggregate Emails</span>
              </v-tooltip>
            </td>
            <td>
              {{ props.item.description }}
            </td>
            <td>
              {{ parseFloat(getPayoutAmount(props.item)) || '-' |toCurrency }}
            </td>
            <td>
              {{ props.item.security_id }}
            </td>
            <td>
              {{ types()[props.item.type] }}
            </td>
            <td>
              <DateDisplay
                :date="props.item.interest_period_begin"
              />
            </td>
            <td>
              <DateDisplay
                :date="props.item.interest_period_end"
              />
            </td>
            <td>
              <DateDisplay
                :date="props.item.expected_payout_date"
              />
            </td>
            <td>
              <DateDisplay
                :date="props.item.created_at"
              />
            </td>
            <td class="text-xs">
              <v-tooltip
                top
                dark
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="selectedPayoutIds.length <= 1"
                    dark
                    flat
                    icon
                    color="primary"
                    v-on="on"
                    @click.stop="() => onSendSingleEmail(props.item.payout_id)"
                  >
                    <v-icon>email</v-icon>
                  </v-btn>
                </template>
                <span>Send Emails</span>
              </v-tooltip>
            </td>
          </tr>
          <tr v-if="props.item.payout_id && selected === props.item.payout_id">
            <td colspan="11">
              <PayoutDetails
                :payout-id="props.item.payout_id"
                :payout="props.item"
                :holders="props.item.holders"
                :show-holders="true"
                :show-holders-address="true"
                :show-holders-payback-information="true"
                :show-address-retry-action="false"
                :show-pdf-download-action="true"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>

    <SendEmailLoanDialog
      :visible="isDialogActive"
      :payout-ids="selectedPayoutIds"
      @close="hideDialog"
    />

    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :auto-height="true"
    >
      <ul v-if="snackbarErrors">
        <li
          v-for="snackbarError in snackbarErrors"
          :key="snackbarError.message"
        >
          {{ snackbarError.message }}
        </li>
      </ul>

      <div
        v-if="snackbarMessage"
      >
        {{ snackbarMessage }}
      </div>

      <v-btn
        color="primary"
        text
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>

import SearchSecurities from '@/components/payoutsAndTaxes/payout/shared/SearchSecurities';
import DateDisplay from '@/components/payoutsAndTaxes/payout/shared/DateDisplay';
import PayoutDetails from '@/components/payoutsAndTaxes/payout/shared/PayoutDetails';
import SendEmailLoanDialog from '@/components/payoutsAndTaxes/payout/dialogs/payoutEmail/SendEmailLoanDialog';

export default {
  name: 'EmailsLoan',
  components: {
    'search-securities': SearchSecurities,
    DateDisplay,
    PayoutDetails,
    SendEmailLoanDialog,
  },
  data() {
    return {
      security: null,
      payouts: null,
      isLoading: false,
      pagination: {
        rowsPerPage: 25,
      },
      selected: 0,
      dialogs: {},
      selectedPayoutIds: [],
      isDialogActive: false,
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      search: '',
      headers: [
        { text: 'Email', value: 'checked' },
        { text: 'Payout', value: 'description' },
        { text: 'Amount', value: 'amount' },
        { text: 'Security ID', value: 'security_id' },
        { text: 'Type', value: 'type' },
        { text: 'Interest Period Begin', value: 'interest_period_begin' },
        { text: 'Interest Period End', value: 'interest_period_end' },
        { text: 'Expected Payout Date', value: 'expected_payout_date' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store.dispatch('fetchPatSecurityListMinimal');
      this.$store.dispatch('fetchPayoutCreationTypes');
    },
    searchSecurities(params) {
      const query = params.query.toLowerCase();

      const result = this.$store.getters.getSecuritiesListMinimal;

      this.selectedPayoutIds = [];

      return result.filter((item) => {
        if (item.type !== 'loan' && item.type !== 'financing_token') {
          return false;
        }

        let found = false;
        Object.keys(item)
          .map((key) => {
            if (item[key] && String(item[key]).toLowerCase().indexOf(query) > -1) {
              found = true;
            }

            return key;
          });

        return found;
      });
    },
    selectSecurity(item) {
      this.security = item;
      const { id } = item;

      this.$store.dispatch('fetchPayoutsFinalApprovedAndSecurityId', id).then((data) => {
        const { payouts } = data;
        this.payouts = payouts;
      });
    },
    getPayoutAmount(payout) {
      if (!payout.holders || payout.holders.length === 0) {
        return payout.amount;
      }

      const initialSumValue = 0;

      return payout.holders.reduce(
        (sum, holder) => sum + holder.payback_information.gross_amount.total || 0,
        initialSumValue,
      );
    },
    types() {
      const data = this.$store.getters.getPayoutsCreationTypes;
      if (!data || !data.payout || !data.payout.types) {
        return {};
      }

      return data.payout.types;
    },
    showDialog() {
      this.isDialogActive = true;
      this.$forceUpdate();
    },
    hideDialog() {
      this.isDialogActive = false;
      this.$forceUpdate();
    },
    toggleSelected(payout) {
      this.selected = this.selected === payout.payout_id ? null : payout.payout_id;
      this.loadPayoutHolders(payout);
    },
    loadPayoutHolders(payout) {
      if (payout.holders && payout.holders.length !== 0) {
        return;
      }

      this.$store.dispatch('fetchPayoutDataGetHolders', {
        payoutId: payout.payout_id,
      })
        .then((data) => {
          const result = this.payouts.filter(p => p.payout_id === payout.payout_id);
          if (result.length !== 0) {
            result[0].holders = data.holders;
          }

          this.$forceUpdate();
        })
        .catch((error) => {
          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
    onSendSingleEmail(payoutId) {
      this.selectedPayoutIds = [payoutId];
      this.showDialog();
    },
    onSendMultiplePayoutEmail() {
      this.showDialog();
    },
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/EmailsLoan.vue